/* eslint-disable camelcase -- Analytics names follow the site's snake_case contract. */
const boundDocuments = new WeakSet();

/**
 * Track the article's three share controls once per click, without delaying sharing.
 * @param {Document} [document]
 */
export function bindShareClickTracking(document = globalThis.document) {
    if (boundDocuments.has(document)) return;
    const window = document.defaultView;

    document.addEventListener('click', (event) => {
        try {
            if (event.defaultPrevented) return;
            const node = event.target.nodeType === 1 ? event.target : event.target.parentElement;
            const control = node?.closest('[data-share-method]');
            if (!control) return;
            const method = control.dataset.shareMethod;
            if (!['x', 'linkedin', 'copy_link'].includes(method)) return;
            const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
            if (modified && control.tagName !== 'A') return;

            // The loader is rendered only when consent gating is configured. Check
            // live consent too: withdrawing it does not unload an initialized client.
            if (document.getElementById('Cookiebot') && !window.Cookiebot?.consent?.statistics) return;
            if (!window.posthog) return;

            const properties = {
                page_path: window.location.pathname.replace(/\/+$/, '') || '/',
                share_method: method,
            };
            // These are public CMS identifiers, already normalized for the page URL.
            const slug = control.closest('[data-share-slug]')?.dataset.shareSlug;
            const postType = control.closest('[data-share-post-type]')?.dataset.sharePostType;
            if (slug) properties.slug = slug;
            if (postType) properties.post_type = postType;

            Promise.resolve(window.posthog.capture('share_click', properties, {
                send_instantly: true,
                transport: 'sendBeacon',
            })).catch(() => {});
        } catch {
            // Sharing must still work when analytics is unavailable or throws.
        }
    });
    boundDocuments.add(document);
}
